// @ts-nocheck

import React from 'react'
import styled from 'styled-components'
import {NamesListTypes} from "../../../components/analytic/NamesList/NamesList";
import {Balance, Block1, Block2, Block3, Block4, Chart, LayoutDesktop, NamesList} from "../../../components/analytic";
import {ChartTypes} from "../../../components/analytic/Chart/Chart";
import {LoadingLayer} from "../../../components/LoadingLayer";
import BreadCrumbsItems from "../../../components/Pages/BreadCrumbsItems/BreadCrumbsItems";

type LayoutTypes = {
    className?: string,
    loading: any,
    chartTypes: ChartTypes,
    readingStart: { checked: any, onChange: any, hide: boolean },
    blocks?: {
        allReading: string | number,
        allErrors: string | number,
        allEarned: string | number,
        minimalTime: any,
        maximumTime: any,
        averageTime: any,
        balance: any
    }
    list: NamesListTypes,
    breadCrumbs: Array<any>

}

function DesktopView(props: LayoutTypes) {

    return (
        <StyledLayout className={props.className}>
            <LayoutDesktop
                leftBar={
                    <>
                        {
                            props?.blocks?.balance === false ? ""  : <Balance
                                className={'balance layout-option'}
                                mainText={props?.blocks?.balance}
                                subText={'Баланс'}/>
                        }


                        <NamesList {...props.list} title={"Список докторов"} className="namesList layout-option"/>
                    </>
                }
                centerBar={
                    <>
                        <div className="breadCrumbs">
                            <BreadCrumbsItems routes={props.breadCrumbs}/>
                        </div>
                        <Chart loading={props.loading} {...props.chartTypes} className={'layout-option'}/>
                        <div className='footer layout-option'>
                            <div className='time'>

                                <Block3 loading={props.loading}
                                        bg={'pink'}
                                        mainText={props?.blocks?.averageTime || 0}
                                        subText={'Среднее время'}
                                        className={'time-block'}/>

                                <Block3 loading={props.loading} bg={'blue'} mainText={props?.blocks?.minimalTime || 0}
                                        subText={'Минимальное время'}
                                        className={'time-block'}/>
                                <Block3 loading={props.loading} bg={"lightBlue"}
                                        mainText={props?.blocks?.maximumTime || 0}
                                        subText={"Максимальное время"}
                                        className={'time-block'}/>
                                <Block1 loading={props.loading} title={'Заработано'}
                                        className={'testResult'}
                                        value={{mainText: props?.blocks?.allEarned || 0, subText: 'Рублей'}}/>
                            </div>

                        </div>
                    </>
                }
                rightBar={
                    <>
                        {!props?.readingStart?.hide &&    <Block4 loading={props.loading}
                                                                 className={"reading layout-option"}
                                                                 title={"Запуск чтения"}
                                                                 changeHandler={props?.readingStart?.onChange}
                                                                 checked={props?.readingStart?.checked}/>}
                        {!props?.qualityControl?.hide &&    <Block4 loading={props.loading}
                                                                 className={"reading layout-option"}
                                                                 title={"Работать за двоих"}
                                                                 changeHandler={props?.qualityControl?.onChange}
                                                                 checked={props?.qualityControl?.checked}/>}

                        <div className='readingCount layout-option'>
                            <Block2 className={'block'}
                                    loading={props.loading}
                                    title={'Всего описано'}
                                    content={{mainText: props?.blocks?.allReading, subText: 'Снимков'}}/>

                            <Block2 loading={props.loading}
                                    className={'block'}
                                    title={'Описано онлайн'}
                                    content={{mainText: props?.blocks?.allErrors, subText: 'Снимков'}}/>
                        </div>

                    </>
                }

            />

        </StyledLayout>
    )
}


const StyledLayout = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  padding-top: 20px;

  .testResult {
    width: 100%;
    align-items: flex-start;
    box-sizing: border-box;
    justify-content: space-around;
    height: max-content;
    padding-left: 40px;
    padding-top: 30px;
    padding-bottom: 40px;
    flex-direction: row;

    .key {
      width: 100%;
      margin-right: 10px;

    }

    .value {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      font-weight: normal;

      b {
        margin: 0;
        margin-right: 15px;
      }
    }
  }

  .left-bar {
    height: 100%;
    width: 19%;

    .balance {
      width: 100%;
      margin-bottom: 30px;
    }

    .namesList {
      width: 100%;
    }
  }

  .main {
    height: 100%;
    width: 58%;
    display: flex;
    flex-direction: column;

    .breadCrumbs {

      .breadCrumbsItems {
        position: static;
        margin-bottom: 15px;
        top: unset;

      }
    }

    .layout-option {
      margin-bottom: 30px;
    }

    .chart {
      margin-bottom: 30px;
    }

    .footer {
      display: flex;
      justify-content: space-between;

      .time {
        display: flex;
        width: 100%;

        .time-block {
          margin-right: 15px;
        }
      }
    }
  }

  .right-bar {
    height: 100%;
    width: 19%;

    .reading {
      width: 100%;
      margin-bottom: 30px;
    }

    .readingCount {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .block {
        width: 45%;
      }
    }
  }
`
export default DesktopView